import { useEffect, useRef, useCallback } from "react";
import ResizeObserver from "resize-observer-polyfill";
var useResizeObserver = function(param) {
    var target = param.target, callback = param.callback;
    var current = target === null || target === void 0 ? void 0 : target.current;
    var observer = useRef(null);
    var observe = useCallback(function() {
        if (target && current && observer.current) {
            observer.current.observe(current);
        }
    }, [
        current,
        target
    ]);
    useEffect(function() {
        if (observer && observer.current && current) {
            observer.current.unobserve(current);
        }
        observer.current = new ResizeObserver(callback);
        observe();
        return function() {
            if (observer && observer.current && target && current) {
                observer.current.unobserve(current);
            }
        };
    }, [
        callback,
        current,
        observe,
        target
    ]);
};
export default useResizeObserver;
